// extracted by mini-css-extract-plugin
module.exports = {"root":"TagGroupPills_root__R7CMU","pills":"TagGroupPills_pills__q9sg_"};